import { css } from "@emotion/react"
import styled from "@emotion/styled"

const dynamicStyle = ({ theme, colorVariant }) => css`
  background: ${(colorVariant !== "Light" && "#efeff6") || theme.palette.common.white};
`

const ListFourItemImageWrapper = styled.div`
  border-radius: 20px 20px 0 0;
  overflow: hidden;
  justify-content: center;
  align-items: center;
  display: flex;

  ${({ theme }) => theme.breakpoints.up("md")} {
    width: 47.9%;
    border-radius: 20px 0 0 20px;
  }

  & > div {
    width: 100%;

    & > svg {
      width: 100%;
    }
  }

  & > a {
    background: red;
  }

  ${dynamicStyle}
`

export default ListFourItemImageWrapper
